import classNames from "classnames";
import { Spinner } from "react-bootstrap";
import styles from "./LoadingButton.module.css";

function LoadingButton({
  isLoading = true,
  title = "",
  className = "",
  center = false,
  onClick = () => {},
  ...props
}) {
  if (isLoading) {
    return (
      <button className={classNames("btn", className)} type="button" {...props}>
        <div
          className={
            "d-flex align-items-center" +
            (center ? " justify-content-center column-gap-1" : "")
          }
        >
          <Spinner className={styles.spinner} />

          <span className="me-1">{title}</span>
        </div>
      </button>
    );
  }

  return (
    <button
      className={classNames("btn", className)}
      onClick={onClick}
      {...props}
    >
      {title}
    </button>
  );
}

export default LoadingButton;
